import { useMutation, gql } from "@apollo/client";
import { useState } from "react";
import Button from 'react-bootstrap/Button';
import { ADD_BOAT } from "./queries";

import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';


import { IoIosAdd } from "react-icons/io";
import { IoIosBoat } from "react-icons/io";


interface CreateBoatProps {
  onBoatCreated: () => void;
}
export default function CreateBoat({ onBoatCreated }: CreateBoatProps) {


  const [boatName, setBoatName] = useState("");
  const [codePf, setCodePf] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [open, setOpen] = useState(false);

  //Mutation GraphQL pour insérer un bateau
  const [addBoat] = useMutation(ADD_BOAT);

  const handleClose = () => setOpen(false);
  const handleShow = () => setOpen(true);

  const handleCreateBoat = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setShowSuccessMessage(false);
    setError(null);

    try {
      const { data, errors } = await addBoat({
        variables: {
          name: boatName,
          codePf: codePf
        }
      });

      setLoading(false);
      setBoatName("");
      setCodePf("");
      setShowSuccessMessage(true);

      setTimeout(() => {
        setShowSuccessMessage(false);
        setOpen(false);
        onBoatCreated();
      }, 1000);
    } catch (err) {
      setLoading(false);
      setError(
        err instanceof Error ? err.message : "Une erreur inconnue est survenue"
      );
    }
  };

  return (
      <>
        <Button onClick={handleShow} className="d-flex justify-content-center custom-gradient-btn create-button">
            <IoIosAdd/><IoIosBoat/>
        </Button>
      
        <Modal show={open} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Ajouter un bateau</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {error && (
              <p className="bg-light text-danger p-3 rounded mb-4 small">
                {error}
              </p>
            )}
            {showSuccessMessage && (
              <p className="bg-success bg-opacity-10 text-success p-3 rounded mb-4 small">
                Bateau créé avec succès !
              </p>
            )}

            <Form onSubmit={handleCreateBoat} className="space-y-4">
                <Form.Group className="mb-3" controlId="inputName">
                  <Form.Control 
                    type="text" 
                    placeholder="Nom du bateau" 
                    value={boatName}
                    onChange={(e) => setBoatName(e.target.value)}
                    required
                  />
                </Form.Group>
              
                <Form.Group className="mb-3" controlId="inputCodePf">
                  <Form.Control 
                    type="text"
                    value={codePf}
                    onChange={(e) => setCodePf(e.target.value)}
                    placeholder="Code Pf"
                    required 
                  />
                </Form.Group>

                <Button
                  type="submit"
                  disabled={loading}
                  className="custom-gradient-btn w-100 fw-medium rounded text-white px-4 py-2"
                >
                  {loading ? "Création en cours..." : "Créer le bateau"}
                </Button>
            </Form>  
          </Modal.Body>
        </Modal>
      </>
  );
};
